import React from 'react';
import TransportRequestPRDViewModel from './TransportRequestPRD.viewmodel';
import TransportRequestTablePRD from './components/TransportRequestTablePRD';
import { Button, Input } from '@chakra-ui/react';

function TransportRequestPRD() {
    const {
        currentPrdPage,
        prdTotalPages,
        currentPagePrdData,

        handleSearchChange,
        fetchTransportRequest,
        handleFetchGetPathFileByPrdTag,
        goToFirstPrdPage,
        goToPrevPrdPage,
        goToNextPrdPage
    } = TransportRequestPRDViewModel();

    return (
        <>
            <div className="flex flex-row items-end justify-between">
                {/* Text search */}
                <div>
                    <label htmlFor="tag">PRD Tag : </label>
                    <div className="flex flex-row items-center gap-4">
                        <Input
                            onChange={e => {
                                handleSearchChange('prdTag', e.target.value);
                            }}
                        />
                        <Button
                            onClick={() => {
                                fetchTransportRequest();
                            }}
                        >
                            Search
                        </Button>
                    </div>
                </div>
                {/* PRD TAG Pagination */}
                {prdTotalPages > 0 && (
                    <div className="mt-3 flex items-center justify-end gap-2">
                        <button
                            onClick={goToFirstPrdPage}
                            disabled={currentPrdPage === 0}
                            className="rounded border border-gray-300 px-3 py-1 text-sm enabled:cursor-pointer enabled:hover:bg-gray-100 disabled:cursor-not-allowed disabled:opacity-40"
                        >
                            ⏮ First
                        </button>
                        <button
                            onClick={goToPrevPrdPage}
                            disabled={currentPrdPage === 0}
                            className="rounded border border-gray-300 px-3 py-1 text-sm enabled:cursor-pointer enabled:hover:bg-gray-100 disabled:cursor-not-allowed disabled:opacity-40"
                        >
                            ◀ Prev
                        </button>
                        <span className="px-2 text-sm font-medium">
                            Page {currentPrdPage + 1} / {prdTotalPages}
                        </span>
                        <button
                            onClick={goToNextPrdPage}
                            disabled={currentPrdPage >= prdTotalPages - 1}
                            className="rounded border border-gray-300 px-3 py-1 text-sm enabled:cursor-pointer enabled:hover:bg-gray-100 disabled:cursor-not-allowed disabled:opacity-40"
                        >
                            Next ▶
                        </button>
                    </div>
                )}
            </div>

            <TransportRequestTablePRD
                transportRequestPrd={currentPagePrdData}
                onClickDowloadFile={handleFetchGetPathFileByPrdTag}
            />
        </>
    );
}

export default TransportRequestPRD;
